import { Tooltip } from "@material-ui/core";


// CT Entrees
import gorditasImage from './images/entrees/gorditas.jpeg';
import tacosImage from './images/entrees/tacos1.jpeg';
import castanedaTacoImage from './images/entrees/castaneda_taco.jpg';
import burritosImage from './images/entrees/burritos.jpeg';
import tortasImage from './images/entrees/tortas.jpeg';

// CT Specials
import birriaImage from './images/specials/Birria.jpeg';
import menudoImage from './images/specials/Menudo.jpeg';

// CT Desserts
import churroPlatterImage from './images/desserts/churro_platter.jpg';
import tresLechesImage from './images/desserts/tres_leches.jpg';

export const menuCategories = [
  {
    id: 1,
    title: 'Entrees',
    // img: appetizerImage,
  },
  {
    id: 2,
    title: 'Sides',
    // img: sidesImage,
  },
  {
    id: 3,
    title: 'Kids Menu',
    // img: kidsMenuImage,
  },
  {

    id: 4,
    title: 'Beverages',
    // img: drinksImage,
  },
  {
    id: 5,
    title: 'Daily Specials',
    // img: specialsImage,
  },
  {
    id: 6,
    title: 'Weekend Specials',
  },
  {
    id: 7,
    title: 'Desserts'
  },
  {
    id: 8,
    title: 'Appetizers'
  }
];

export const meatChoices = [
  {
    spanish: 'Asada',
    english: 'Beef Skirt Steak'
  },
  {
    spanish: 'Bistek',
    english: 'Steak'
  },
  {
    spanish: 'Pollo',
    english: 'Chicken'
  },
  {
    spanish: 'Al Pastor',
    english: 'Marinated Pork'
  },
  {
    spanish: 'Chorizo',
    english: 'Mexican Sausage'
  },
  {
    spanish: 'Carnitas',
    english: 'Shredded Pork'
  },
  {
    spanish: 'Camarón',
    english: 'Shrimp'
  },
  {
    spanish: 'Lengua',
    english: 'Beef Tongue'
  },
  {
    spanish: 'Pescado',
    english: 'Fish'
  },
  {
    spanish: 'Rajas con queso',
    english: 'Veggies with cheese'
  }
];

const tooltipInfo = <ul>{meatChoices.map((mc) => (
  <li>{mc.spanish} ({mc.english})</li>
  )
)}</ul>

export const menuItems = [
  {
    id: 1,
    categoryId: 1,
    name: 'Tacos',
    description: <span>
      Corn tortilla with your <Tooltip
        title={tooltipInfo}
        arrow
        placement="top"
      ><span className="choice-of-meat"> choice of meat*</span>
      </Tooltip>. Comes with onion, cilantro, grilled onions and a grilled jalapeno.</span>,
    meatChoices,
    price: '$2.00',
    img: tacosImage,
    position: 'center',
  }, {
    id: 2,
    categoryId: 1,
    name: 'Burritos',
    description: <span>
      Flour tortilla with your <Tooltip
      title={tooltipInfo}
      arrow
      placement="top"
    ><span className="choice-of-meat"> choice of meat*</span>
      </Tooltip>. Comes with rice, beans, jalapeños, lettuce, tomato, onion, cheese, and avocado.</span>,
    meatChoices,
    price: '$8.00',
    img: burritosImage,
    position: 'bottom',
  }, {
    id: 3,
    categoryId: 1,
    name: 'Tortas',
    description: <span>
      Grilled Mexican sandwich with your <Tooltip
      title={tooltipInfo}
      arrow
      placement="top"
    ><span className="choice-of-meat"> choice of meat*</span>
      </Tooltip>. Comes with beans, jalapeños, lettuce, tomato, onion, cheese, and avocado.</span>,
    meatChoices,
    price: 'Sm. $6.00/Lg. $8.00)',
    img: tortasImage,
    position: 'bottom',
  },
  {
    id: 4,
    categoryId: 1,
    name: 'Quesadilla',
    description: <span>
      Grilled flour tortilla with cheese and your <Tooltip
      title={tooltipInfo}
      arrow
      placement="top"
    ><span className="choice-of-meat"> choice of meat*</span>
      </Tooltip>. Comes with cheese, lettuce, tomato, onion, avocado, and jalapeños.</span>,
    meatChoices,
    price: '$8.00',
    // img: quesadillasImage
  },
  {
    id: 33,
    categoryId: 1,
    name: 'Gorditas',
    description: <span>
      Corn masa pastry stuffed with cheese, your  <Tooltip
      title={tooltipInfo}
      arrow
      placement="top"
    ><span className="choice-of-meat"> choice of meat*</span>
      </Tooltip>, onion, cilantro, and beans.</span>,
    meatChoices,
    img: gorditasImage,
    price: '$3.50 each'
  },
  {
    id: 47,
    categoryId: 1,
    name: 'Castañeda Taco',
    description: 'Deep fried flour tortilla with ground beef, fried diced potatoes, American cheese, lettuce, tomato, and sour cream.',
    img: castanedaTacoImage,
    position: 'center'
    // price: '$3.50 each'
  },
  {
    id: 5,
    categoryId: 2,
    name: 'Rice',
    price: '$2.00',
    // img: riceImage,
  },
  {
    id: 6,
    categoryId: 2,
    name: 'Beans',
    price: '$2.00',
    // img: beansImage,
  },
  {
    id: 7,
    categoryId: 2,
    name: 'Rice and Beans',
    price: '$3.50',
    // img: riceAndBeansImage,
  },
  {
    id: 8,
    categoryId: 2,
    name: 'French Fries',
    price: '$1.75',
    // img: frenchFriesImage,
  },
  {
    id: 9,
    categoryId: 2,
    name: 'Chips',
    price: '$3.50',
    // img: chipsImage,
  },
  {
    id: 10,
    categoryId: 2,
    name: 'Salsa',
    price: '$2.50',
    // img: salsaImage,
  },
  {
    id: 11,
    categoryId: 2,
    name: 'Guacamole',
    price: '$3.50',
    // img: guacamoleImage,
  },
  {
    id: 12,
    categoryId: 2,
    name: 'Pico de Gallo',
    price: '$2.50',
    // img: picoImage,
  },
  {
    id: 13,
    categoryId: 2,
    name: 'Sour cream',
    price: '$1.00',
    // img: sourCreamImage,
  },
  {
    id: 14,
    categoryId: 2,
    name: 'Shredded cheese',
    price: '$1.00',
    // img: shreddedCheeseImage,
  },
  {
    id: 15,
    categoryId: 2,
    name: 'Jalapeños',
    price: '$1.00',
    // img: jalapenosImage,
  },
  {
    id: 16,
    categoryId: 2,
    name: 'Ranch',
    price: '$1.00',
    // img: ranchImage,
  },
  // {
  //   id: 17,
  //   categoryId: 2,
  //   name: 'Mozzarella Sticks (6)',
  //   price: '$4.00',
  //   img: mozzarellaSticksImage,
  // },
  // {
  //   id: 18,
  //   categoryId: 2,
  //   name: 'Jalapeño Poppers (6)',
  //   price: '$4.00',
  //   img: jalapenoPoppersImage,
  // },
  {
    id: 19,
    categoryId: 2,
    name: 'Grilled Onions',
    price: '$1.50',
    // img: grilledOnionsImage,
  },

  // Kids Menu

  {
    id: 20,
    categoryId: 3,
    name: 'Tacos (2) with Rice & Beans',
    price: '$4.99',
    meatChoices,
    // img: tacosImage,
  },
  {
    id: 21,
    categoryId: 3,
    name: 'Chicken Nuggets & Fries',
    price: '$4.99',
    // img: ,
  },
  {
    id: 22,
    categoryId: 3,
    name: 'Cheese Quesadilla with Rice & Beans',
    price: '$4.99',
    // img: ,
  },
  // {
  //   id: 23,
  //   categoryId: 3,
  //   name: 'Cheeseburger & Fries',
  //   price: '$4.99',
  //   // img: ,
  // },
  // {
  //   id: 24,
  //   categoryId: 3,
  //   name: 'Hot Dog & Fries',
  //   price: '$4.99',
  //   // img: ,
  // },

  // Beverages
  {
    id: 42,
    categoryId: 4,
    name: 'Beer',
  },
  {
    id: 43,
    categoryId: 4,
    name: 'Seltzer',
  },
  {
    id: 44,
    categoryId: 4,
    name: 'Wine',
  },
  {
    id: 45,
    categoryId: 4,
    name: 'Margaritas',
    description: 'Available frozen or on the rocks',
  },
  {
    id: 46,
    categoryId: 4,
    name: 'Cocktails',
  },
  {
    id: 28,
    categoryId: 4,
    name: 'Jarritos (Various Flavors)',
    price: '$1.50',
  },
  {
    id: 25,
    categoryId: 4,
    name: 'Soft Drinks',
    price: '$1.75',
    description: 'Coke and Pepsi products.'
  },
  {
    id: 26,
    categoryId: 4,
    name: 'Lemonade',
    price: '$1.75',
  },
  {
    id: 27,
    categoryId: 4,
    name: 'Iced Tea',
    price: '$1.75',
    description: 'Sweetened and Unsweetened',
  },
  // {
  //   id: 29,
  //   categoryId: 4,
  //   name: 'Bottled Water',
  //   price: '$1.50',
  // },
  {
    id: 30,
    categoryId: 6,
    name: 'Menudo',
    description: 'Traditional Mexican soup made with cow’s stomach in a red chili pepper broth. Comes with corn tortillas, diced onions, cilantro, and a slice of lime.',
    img: menudoImage,
    price: 'Sm. $10.00/Lg. $15.00',
  },
  {
    id: 31,
    categoryId: 6,
    name: 'Birria',
    description: 'Traditional Mexican meat stew made with goat meat topped with a red chili sauce. Comes with corn tortillas, diced onions, cilantro, and a slice of lime.',
    img: birriaImage,
    price: '$11.00',
  },
  // {
  //   id: 32,
  //   categoryId: 6,
  //   name: 'Consommé',
  //   description: 'Traditional Mexican clear soup made from richly flavored goat stock. Comes with diced onions, cilantro, and a slice of lime.',
  //   price: '$8.00',
  // },
  {
    id: 33,
    categoryId: 7,
    name: 'Churro',
    description: 'Plain, Strawberry Filled, or Cajeta Filled',
    price: '$1.25'
  },
  {
    id: 34,
    categoryId: 7,
    name: 'Churro Platter',
    img: churroPlatterImage,
    price: '$4.50'
  },
  {
    id: 35,
    categoryId: 7,
    name: 'Strawberry Crunch Tres Leche Cake',
    img: tresLechesImage,
    price: '$2.25/slice'
  },

  // Appetizers
  {
    id: 36,
    categoryId: 8,
    name: 'Chicken Wings (8)',
    price: '$10.99'
  },
  {
    id: 37,
    categoryId: 8,
    name: 'Butterfly Shrimp (8)',
    price: '$10.99'
  },
  {
    id: 38,
    categoryId: 8,
    name: 'Onion Rings (6)',
    price: '$4.99'
  },
  {
    id: 39,
    categoryId: 8,
    name: 'Jalapeño Poppers (6)',
    price: '$4.99',
  },
  {
    id: 40,
    categoryId: 8,
    name: 'Mozzarella Sticks (6)',
    price: '$5.99',
  },
  {
    id: 41,
    categoryId: 8,
    name: 'Cheese Dip/Queso Dip',
    price: '$3.99',
  },
];

export const getItemsByCategory = (categoryId) => menuItems.filter((item) => item.categoryId === categoryId);
